import { uiActions } from './index';
import ActionTypes from './../common/ActionTypes';
import Strings from '../common/Strings';

const firebase = require('firebase/app');
require('firebase/functions');

function subscriptionLoading(loading) {
  return {
    type: ActionTypes.SUBSCRIPTION_LOADING,
    loading,
  };
}

function subscriptionFailed(failed) {
  return {
    type: ActionTypes.SUBSCRIPTION_FAILED,
    failed,
  };
}

function paymentCardLoading(loading) {
  return {
    type: ActionTypes.USER_PAYMENT_CARD_LOADING,
    loading,
  };
}

function paymentCardUpdated(data) {
  return {
    type: ActionTypes.USER_PAYMENT_CARD_UPDATED,
    data,
  };
}

function paymentCardFailed(failed) {
  return {
    type: ActionTypes.USER_PAYMENT_CARD_FAILED,
    failed,
  };
}

function paymentHistoryLoading(loading) {
  return {
    type: ActionTypes.USER_PAYMENT_HISTORY_LOADING,
    loading,
  };
}

function paymentHistoryUpdated(data) {
  return {
    type: ActionTypes.USER_PAYMENT_HISTORY_UPDATED,
    data,
  };
}

function paymentHistoryFailed(failed) {
  return {
    type: ActionTypes.USER_PAYMENT_HISTORY_FAILED,
    failed,
  };
}

function upcomingInvoiceLoading(loading) {
  return {
    type: ActionTypes.USER_UPCOMING_INVOICE_LOADING,
    loading,
  };
}

function upcomingInvoiceUpdated(data) {
  return {
    type: ActionTypes.USER_UPCOMING_INVOICE_UPDATED,
    data,
  };
}

function upcomingInvoiceFailed(failed) {
  return {
    type: ActionTypes.USER_UPCOMING_INVOICE_FAILED,
    failed,
  };
}

function subscriptionUpdated(data) {
  return {
    type: ActionTypes.SUBSCRIPTION_UPDATED,
    data,
  };
}

function paymentCardDeleted(data) {
  return {
    type: ActionTypes.USER_PAYMENT_CARD_DELETED,
    data,
  };
}

function checkoutSessionUpdated(session) {
  return {
    type: ActionTypes.PREMIUM_CHECKOUT_SESSION,
    session,
  };
}

function checkoutSessionCleared() {
  return {
    type: ActionTypes.CHECKOUT_SESSION_CLEARED,
    session: null,
  };
}

function clientSecretUpdated(clientSecret) {
  return {
    type: ActionTypes.PREMIUM_CLIENT_SECRET,
    clientSecret,
  };
}

function paymentMethodAdded(data) {
  return {
    type: ActionTypes.PAYMENT_METHOD_ADDED,
    data,
  };
}

function subscribePremiumPlan(token) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(subscriptionLoading(true));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('subscribePlan');
          httpsCallable(JSON.stringify({ idToken, token }))
            .then(response => {
              const subscription = response.data;
              dispatch(subscriptionLoading(false));
              dispatch(subscriptionUpdated(subscription));
              dispatch(getPaymentCards());
              dispatch(getPaymentHistory());
              dispatch(getUpcomingInvoice());
              if (subscription.status === 'active') {
                dispatch(
                  uiActions.showSuccess(
                    Strings.BILLING.successfulPremiumTitle,
                    Strings.BILLING.successfulPremiumText,
                  ),
                );
              } else if (subscription.status === 'incomplete') {
                dispatch(
                  uiActions.showError(
                    Strings.ERROR.paymentFailedErrorTitle,
                    Strings.ERROR.paymentFailedError,
                  ),
                );
              }
            })
            .catch(e => {
              dispatch(checkSubscription());
              let message;
              switch (e.code) {
                case 'internal':
                  message = Strings.ERROR.genericInternal;
                  break;
                case 'invalid-argument':
                  message = Strings.ERROR.genericBadRequest;
                  break;
                default:
                  message = Strings.ERROR.genericDefault;
              }
              dispatch(
                uiActions.showError(Strings.ERROR.genericTitle, message),
              );
            });
        })
        .catch(() => {
          dispatch(checkSubscription());
          dispatch(
            uiActions.showError(
              Strings.ERROR.genericTitle,
              Strings.ERROR.genericDefault,
            ),
          );
        });
    }
  };
}

function getPremiumCheckOutSession() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('subscribePlanNewCheckOut');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              let session = response.data.session;
              dispatch(checkoutSessionUpdated(session));
            })
            .catch(() => {
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            })
            .catch(() => {
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            });
        });
    }
  };
}

function getPremiumClientSecret() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('getClientSecret');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(clientSecretUpdated(response.data.clientSecret));
            })
            .catch(e => {
              console.log(e);
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            })
            .catch(e => {
              console.log(e);
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            });
        });
    }
  };
}

function createPaymentMethod(token) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('createPaymentMethod');
          httpsCallable(JSON.stringify({ idToken, token }))
            .then(response => {
              dispatch(paymentMethodAdded(response.data.id));
            })
            .catch(e => {
              console.log(e);
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            })
            .catch(e => {
              console.log(e);
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            });
        });
    }
  };
}

function attachPaymentMethod(setupIntent) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('attachPaymentMethod');
          httpsCallable(JSON.stringify({ idToken, setupIntent }))
            .then(() => {
              dispatch(getPaymentCards());
              dispatch(
                uiActions.showSuccess(
                  Strings.BILLING.paymentUpdated,
                  Strings.BILLING.paymentUpdatedText,
                ),
              );
            })
            .catch(e => {
              console.log(e);
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            })
            .catch(e => {
              console.log(e);
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            });
        });
    }
  };
}

function getPaymentCards() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(paymentCardLoading(true));
      dispatch(paymentCardFailed(false));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('getPaymentCards');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(paymentCardLoading(false));
              dispatch(paymentCardUpdated(response.data));
            })
            .catch(() => {
              dispatch(paymentCardLoading(false));
              dispatch(paymentCardFailed(true));
            });
        })
        .catch(() => {
          dispatch(paymentCardLoading(false));
          dispatch(paymentCardFailed(true));
        });
    }
  };
}

function getPaymentHistory() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(paymentHistoryLoading(true));
      dispatch(paymentHistoryFailed(false));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('getPaymentHistory');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(paymentHistoryLoading(false));
              dispatch(paymentHistoryUpdated(response.data));
            })
            .catch(() => {
              dispatch(paymentHistoryLoading(false));
              dispatch(paymentHistoryFailed(true));
            });
        })
        .catch(() => {
          dispatch(paymentHistoryLoading(false));
          dispatch(paymentHistoryFailed(true));
        });
    }
  };
}

function getUpcomingInvoice() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(upcomingInvoiceLoading(true));
      dispatch(upcomingInvoiceFailed(false));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('getUpcomingInvoice');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(upcomingInvoiceLoading(false));
              dispatch(upcomingInvoiceUpdated(response.data));
            })
            .catch(() => {
              dispatch(upcomingInvoiceLoading(false));
              dispatch(upcomingInvoiceFailed(true));
            });
        })
        .catch(() => {
          dispatch(upcomingInvoiceLoading(false));
          dispatch(upcomingInvoiceFailed(true));
        });
    }
  };
}

function restoreSubscription() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(subscriptionLoading(true));
      dispatch(subscriptionFailed(false));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('restoreSubscription');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(subscriptionLoading(false));
              dispatch(subscriptionUpdated(response.data));
              dispatch(getUpcomingInvoice());
              dispatch(
                uiActions.showSuccess(
                  Strings.BILLING.success,
                  Strings.BILLING.successfulRestoration,
                ),
              );
            })
            .catch(() => {
              dispatch(checkSubscription());
            });
        })
        .catch(() => {
          dispatch(subscriptionLoading(false));
          dispatch(subscriptionFailed(true));
        });
    }
  };
}

function checkSubscription() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(subscriptionLoading(true));
      dispatch(subscriptionFailed(false));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('checkSubscription');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(subscriptionLoading(false));
              dispatch(subscriptionUpdated(response.data));
            })
            .catch(() => {
              dispatch(subscriptionLoading(false));
              dispatch(subscriptionFailed(true));
            });
        })
        .catch(() => {
          dispatch(subscriptionLoading(false));
          dispatch(subscriptionFailed(true));
        });
    }
  };
}

function cancelSubscription() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(subscriptionLoading(true));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('cancelSubscription');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(subscriptionLoading(false));
              dispatch(subscriptionUpdated(response.data));
              dispatch(getUpcomingInvoice());
              dispatch(
                uiActions.showSuccess(
                  Strings.BILLING.success,
                  Strings.BILLING.successfullyCanceled,
                ),
              );
            })
            .catch(e => {
              dispatch(checkSubscription());
              let message;
              switch (e.code) {
                case 'internal':
                  message = Strings.ERROR.genericInternal;
                  break;
                case 'invalid-argument':
                  message = Strings.ERROR.genericBadRequest;
                  break;
                default:
                  message = Strings.ERROR.genericDefault;
              }
              dispatch(
                uiActions.showError(Strings.ERROR.genericTitle, message),
              );
            });
        })
        .catch(() => {
          dispatch(checkSubscription());
          dispatch(
            uiActions.showError(
              Strings.ERROR.genericTitle,
              Strings.ERROR.genericDefault,
            ),
          );
        });
    }
  };
}

function deletePaymentCard() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(paymentCardLoading(true));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('deletePaymentCard');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              dispatch(paymentCardDeleted(response.data));
              dispatch(paymentCardLoading(false));
              dispatch(
                uiActions.showSuccess(
                  Strings.BILLING.successfullyRemoved,
                  Strings.BILLING.successfullyDeleted,
                ),
              );
            })
            .catch(() => {
              dispatch(getPaymentCards());
              dispatch(
                uiActions.showError(
                  Strings.ERROR.deleteCardErrorTitle,
                  Strings.ERROR.deleteCardError,
                ),
              );
            });
        })
        .catch(() => {
          dispatch(getPaymentCards());
          dispatch(
            uiActions.showError(
              Strings.ERROR.genericTitle,
              Strings.ERROR.genericDefault,
            ),
          );
        });
    }
  };
}

function retryPayment() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(subscriptionLoading(true));
      dispatch(subscriptionFailed(false));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('retryPayment');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              const subscription = response.data;
              dispatch(subscriptionLoading(false));
              dispatch(subscriptionUpdated(subscription));
              dispatch(getUpcomingInvoice());
              dispatch(getPaymentHistory());
              if (subscription.status === 'active') {
                dispatch(
                  uiActions.showSuccess(
                    Strings.BILLING.successfulPremiumTitle,
                    Strings.BILLING.successfulPremiumText,
                  ),
                );
              } else if (subscription.status === 'incomplete') {
                dispatch(
                  uiActions.showError(
                    Strings.ERROR.paymentFailedErrorTitle,
                    Strings.ERROR.paymentFailedError,
                  ),
                );
              }
            })
            .catch(() => {
              dispatch(checkSubscription());
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            });
        })
        .catch(() => {
          dispatch(checkSubscription());
          dispatch(
            uiActions.showError(
              Strings.ERROR.genericTitle,
              Strings.ERROR.genericDefault,
            ),
          );
        });
    }
  };
}

function endSubscription() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(subscriptionLoading(true));
      dispatch(subscriptionFailed(false));
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('endSubscription');
          httpsCallable(JSON.stringify({ idToken }))
            .then(response => {
              const subscription = response.data;
              dispatch(subscriptionLoading(false));
              dispatch(subscriptionUpdated(subscription));
              dispatch(getUpcomingInvoice());
              if (subscription.status === 'active') {
                dispatch(
                  uiActions.showSuccess(
                    Strings.BILLING.success,
                    Strings.BILLING.successfullyEnded,
                  ),
                );
              } else if (subscription.status === 'incomplete') {
                dispatch(
                  uiActions.showError(
                    Strings.ERROR.paymentFailedErrorTitle,
                    Strings.ERROR.paymentFailedError,
                  ),
                );
              }
            })
            .catch(() => {
              dispatch(checkSubscription());
              dispatch(
                uiActions.showError(
                  Strings.ERROR.genericTitle,
                  Strings.ERROR.genericDefault,
                ),
              );
            });
        })
        .catch(() => {
          dispatch(checkSubscription());
          dispatch(
            uiActions.showError(
              Strings.ERROR.genericTitle,
              Strings.ERROR.genericDefault,
            ),
          );
        });
    }
  };
}

export const paymentActions = {
  subscribePremiumPlan,
  getPaymentCards,
  getPaymentHistory,
  getUpcomingInvoice,
  checkSubscription,
  cancelSubscription,
  deletePaymentCard,
  restoreSubscription,
  retryPayment,
  endSubscription,
  getPremiumCheckOutSession,
  checkoutSessionCleared,
  getPremiumClientSecret,
  createPaymentMethod,
  attachPaymentMethod,
  paymentCardLoading,
};



// WEBPACK FOOTER //
// ./src/actions/payment.js